/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export type LookupType =
  'QUEUE' | 
  'WRAPUP' | 
  'USER'


export function LookupTypeFromJSON(json: any): LookupType {
    return LookupTypeFromJSONTyped(json, false);
}

export function LookupTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): LookupType {
    return json as LookupType;
}

export function LookupTypeToJSON(value?: LookupType | null): any {
    return value as any;
}

